import { z } from 'zod';
import { EntitySchema, EventEntityChangeSchema } from './shared.schema';

/**
 * Event schema.
 * Master source for Event entity structure.
 */
export const EventSchema = EntitySchema.omit({
  images: true,
  primaryImageId: true,
  mainImageUrl: true,
  mainImagePath: true,
}).extend({
  type: z.string().optional().describe('Type of event (e.g., battle, assassination, discovery)'),
  date: z.string().optional().describe('The date or timeframe of the event.'),
  location: z.string().optional().describe('Where the event takes place (textual description)'),
  whyItMatters: z.string().optional().describe('Why the event matters to the story.'),
  involvedFactions: z.string().optional().describe('Involved factions or organizations.'),
  coverImageUrl: z.string().url().optional().describe('Cloud Storage URL to the events primary image.'),

  isNarrativelyComplete: z.boolean().optional().describe('Manual flag to indicate if this event is narratively complete.'),
  causesEventIds: z.array(z.string()).optional().describe('Event IDs that this event causes (for graph edges)'),
  structureSectionId: z.string().optional().describe('Reference to the structure section this event belongs to'),

  // Linkages
  characterIds: z.array(z.string()).optional(),
  organizationIds: z.array(z.string()).optional(),
  locationIds: z.array(z.string()).optional(),
  primaryLocationId: z.string().optional(),
  arcId: z.string().optional(),
  order: z.number().optional(),
  eventChanges: z.array(EventEntityChangeSchema).optional(),
});

export type Event = z.infer<typeof EventSchema>;

